exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Backdrop {\r\n    width:100%;\r\n    height:100%;\r\n    position: absolute;\r\n    z-index: 100;\r\n    left:0;\r\n    top:0;\r\n    background-color: rgba(0, 0, 0, 0.5)\r\n\r\n\r\n}", ""]);

// exports
